import moment from "moment";

export default function Barcode({ ticket }) {
  const code = moment(ticket.date, "DD/MM/YYYY").valueOf();
  const src = `https://barcode.tec-it.com/barcode.ashx?data=${code}&code=`;

  return (
    <img
      className="-rotate-90 mix-blend-multiply origin-center w-24 max-w-none"
      alt="Barcode Generator TEC-IT"
      src={src}
    />
  );
}
